import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {EventsService} from '@services/events.service';
import {EquipmentCardPagingApiService} from '@api/equipment-card-paging.api.service';
import {EquipmentListPagesService} from '../../services/equipment-list/equipment-list-pages.service';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {UserNamespace} from '@namespaces/user.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';

@Component({
    selector: 'app-equipment-list',
    templateUrl: 'equipment-list.component.html',
    providers: [
        /**
         * Для компонента выбора оборудования
         */
        {provide: 'EquipmentCardSelectApiService', useClass: EquipmentCardPagingApiService},
    ]
})

export class EquipmentListComponent extends ListItemsComponent<EquipmentListPagesService> implements OnInit {
    public permissions = UserNamespace.Permission;

    public equipmentListUrl = RoutesStorage.Equipment.list;

    constructor(
        private api: WorkingObjectsApiService,
        private route: ActivatedRoute,
        private events: EventsService,
        service: EquipmentListPagesService,
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    /**
     * Обработчик выбора карточек оборудования
     * @param newIds
     */
    onCardsSelect(newIds: number[]): void {
        /**
         * Привязываем новое оборудование
         */
        this.api.post({
            url: this.api.getEquipmentPath(this.service.objectId),
            dataBody: {
                cardIds: newIds,
            }
        }).toPromise().then(() => {
            this.events.showNoty({
                type: 'success',
                content: NotyMessagesEnum.workingObjectEquipmentListUpdatedMessage,
            });
            this.service.updateItems();
        }, () => {
            this.events.showNoty({
                type: 'error',
                content: NotyMessagesEnum.workingObjectEquipmentListUpdatedFailMessage,
            });
        });
    }

    removeCard(card: EquipmentCardInterfaces.Card.ItemView) {
        this.api.deleteMultiple({
            url: this.api.getEquipmentPath(this.service.objectId),
            queryParams: {
                cardIds: [card.id]
            }
        }).toPromise().then(() => {
            this.events.showNoty({
                type: 'success',
                content: NotyMessagesEnum.workingObjectEquipmentListRemoveMessage,
            });
            this.service.updateItems();
        }, () => {
            this.events.showNoty({
                type: 'error',
                content: NotyMessagesEnum.workingObjectEquipmentListRemoveFailMessage,
            });
        });
    }
}
